import React, { useContext, useEffect, useState } from "react";
import {
  DropdownMenu,
  DropdownToggle,
  Label,
  UncontrolledDropdown,
  Modal,
  ModalBody,
  DropdownItem,
  Form,
  ModalHeader,
  ModalFooter,
  Row,
  Card
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Col,
  PaginationComponent,
  Button,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  TooltipComponent,
  RSelect,
  PreviewAltCard,
} from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { filterStatus, userData } from "./UserData";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { UserContext } from "./UserContext";
import InputMask from 'react-input-mask';
import Api from "../../../Api";
import { cloneDeep, first } from "lodash";
import Swal from "sweetalert2";
import Loaders from "../../components/loader/Loaders";
import { GetTenantIdUp, extractError, formDataUsername, usaNumRegex, usaNumRegex2, userTypeId } from "../../../utils/Utils";

const ManageUsers = () => {
  let addUserDetails = {
    "tuid": 0,
    "tenantId": +GetTenantIdUp(),
    "userType": +userTypeId(),
    "userName": "",
    "password": "",
    "firstName": "",
    "middleName": "",
    "lastName": "",
    "emailId": "",
    "lastlogin": "",
    "createdBy": formDataUsername(),
    "createdOn": "",
    "updateBy": formDataUsername(),
    "updateOn": "",
    "isActive": true,
    "tenant": [
      GetTenantIdUp()?.toString()
    ],
    "userPhone": {
      "uphId": 0,
      "usrId": 0,
      "phoneType": "",
      "phoneNo": "",
      "createdBy": "",
      "createdOn": "",
      "updateBy": "",
      "updateOn": "",
      "isActive": true
    }
  }

  const filterUserType = [
    { value: 1, label: "Administrator" },
    { value: 2, label: "Admin" },
    { value: 3, label: "ImplementationSpecialist" },
    { value: 4, label: "CallCenterExecutive" },
    { value: 5, label: "AccountManager" },
    { value: 6, label: "TechnicalSupport" },
    { value: 7, label: "SalesManager" },
  ];
  const [addUserDetailsState, setAddUserDetail] = useState(addUserDetails);
  const [sampleDetail, setSampleDetail] = useState({});
  //setTenantDetail(addUserDetails);
  const [editUserDetailsState, setEditUserDetail] = useState(addUserDetails);
  const [usersDataState, setTenant] = useState([]);

  const [TenantListState, setTenantList] = useState([]);
  const [TenantDetailsState, setTenantDetails] = useState({});
  const [statusState, setStatus] = useState(true);

  const [searchUserNameState, setSearchUserName] = useState({
    userName: "",
    firstName: "",
    lastName: "",
  });

  const [loader, setLoader] = useState(false);


  const callGetUserData = async () => {
    setLoader(true);
    try {
      const userData2 = await Api.GetTenantUserTable({ IsActive: true, UserName: "", TenantId: +GetTenantIdUp() });
      setTenant(userData2);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }

  }
  const callGetTenantList = async () => {
    try {
      const TenantList = await Api.GetTenantList();
      if (TenantList?.statusCode !== 108) {
        setTenantList(TenantList)
      }
    } catch (error) {
    }
  }
  const callGetTenantDetailsByUserName = async (userName) => {
    try {
      const TenantDetails = await Api.GetTenantDetailsByUserName(userName);
      setTenantDetails(TenantDetails);
      return TenantDetails
    } catch (error) {
    }
  }
  useEffect(async () => {
    setSampleDetail(addUserDetails);
    await callGetUserData();
    await paginate(1);
    // await callGetTenantList();
    // await paginate(1);
  }, []);
  const { contextData } = useContext(UserContext);
  const [data, setData] = contextData;

  const [sm, updateSm] = useState(false);
  const [onSearchText] = useState("");
  const [modal, setModal] = useState({
    add: false,
  });
  const [editModal, setEditModal] = useState(false);
  const [editId, setEditedId] = useState(0);
  const [formData, setFormData] = useState({
    username: "",
    firstname: "",
    lastname: "",
    email: "",
    balance: "",
    phone: "",
    status: "Active",
  });
  const [currentPage, setCurrentPage] = useState(1);
  // const [modalForm, setModalForm] = useState(false);
  const [itemPerPage] = useState(10);
  const [totalItems, SetTotalItems] = useState(1);
  const [regexs, setRegexs] = useState({
    name: /^[a-zA-Z0-9 .]+$/,
    password: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>]).{8,16}$/,
    email: /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/,
    phone: /^\(\d{3}\) \d{3}-\d{4}$/,
  });
  const [passState, setPassState] = useState(false);

  const [error, setError] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    userName: "",
    password: "",
    emailId: "",
    phoneNumber: "",
    SomethingWentWrong: "",
  });

  const [editUserType, setEditUserType] = useState({
    value: 1,
    label: "Administrator",
  });

  const [editForm, setEditForm] = useState({
    "tuid": 0,
    "tenantId": +GetTenantIdUp(),
    "userType": "",
    "userName": "",
    "password": "",
    "firstName": "",
    "middleName": "",
    "lastName": "",
    "emailId": "",
    "lastlogin": "",
    "createdBy": "",
    "createdOn": "",
    "updateBy": "",
    "updateOn": "",
    "isActive": true,
    "tenant": [
      "1"
    ],
    "userPhone": {
      "phoneNo": "",
    }
  })

  const [editError, setEditError] = useState({
    firstName: "",
    lastName: "",
    middleName: "",
    userName: "",
    password: "",
    emailId: "",
    phoneNo: "",
    SomethingWentWrong: "",
  });

  // useEffect(() => {
  //   let newData;
  //   newData = userData.map((item) => {
  //     item.checked = false;
  //     return item;
  //   });
  //   setData([...newData]);
  // }, []); 

  // Changing state value when searching name
  useEffect(() => {
    if (onSearchText !== "") {
      const filteredObject = userData.filter((item) => {
        return (
          item.name.toLowerCase().includes(onSearchText.toLowerCase()) ||
          item.email.toLowerCase().includes(onSearchText.toLowerCase())
        );
      });
      setData([...filteredObject]);
    } else {
      setData([...userData]);
    }
  }, [onSearchText, setData]);

  // const toggleForm = () => setModalForm(!modalForm);

  // function to change the selected property of an item
  const onSelectChange = (e, id) => {
    let newData = data;
    let index = newData.findIndex((item) => item.id === id);
    newData[index].checked = e.currentTarget.checked;
    setData([...newData]);
  };

  // function to reset the form
  const resetForm = () => {
    setFormData({
      username: "",
      firstname: "",
      lastname: "",
      email: "",
      balance: "",
      phone: "",
      status: "Active",
    });
  };

  const resetError = () => {
    setError({
      ...error,
      firstName: "",
      middleName: "",
      lastName: "",
      userName: "",
      password: "",
      emailId: "",
      phoneNumber: "",
      SomethingWentWrong: "",
    });
  }

  // function to close the form modal
  const onFormCancel = () => {
    // setModal({ edit: false, add: false });
    setModal({ ...modal, add: false });
    setEditModal(false);
    resetForm();
  };

  const onEditClick = async (id, userName) => {
    resetError();
    let getEditUser = await callGetTenantDetailsByUserName(userName);
    setEditedId(id);
    if (getEditUser?.userPhone !== null) {
      setTenantDetails({
        ...TenantDetailsState, phoneNo: (getEditUser?.userPhone?.phoneNo)?.replace("+1", ""),
        firstName: getEditUser?.firstName,
        middleName: getEditUser?.middleName,
        lastName: getEditUser?.lastName,
        emailId: getEditUser?.emailId,
        userName: getEditUser?.userName,
        password: getEditUser?.password,
      });
      setEditForm({
        ...editForm, firstName: getEditUser?.firstName,
        middleName: getEditUser?.middleName,
        lastName: getEditUser?.lastName,
        emailId: getEditUser?.emailId,
        userName: getEditUser?.userName,
        password: getEditUser?.password,
        tuid: id,
        userType: getEditUser?.userType,
        createdBy: formDataUsername(),
        userPhone: {
          ...editForm?.userPhone,
          phoneNo: (getEditUser?.userPhone?.phoneNo)?.replaceAll("+1", "")
        },

      })
      let findUserType = filterUserType?.findIndex(ele => ele?.value === +getEditUser?.userType);
      if (findUserType !== -1) {
        setEditUserType({
          ...editUserType, value: filterUserType[findUserType]?.value, label: filterUserType[findUserType]?.label
        });
        // setModal({ ...modal, edit: true, add: false })
        setEditModal(true);
      }else{
        Swal.fire({
          icon: "error",
          title: "Something Went Wrong"
        })
      }

    } else {
      Swal.fire({
        icon: "error",
        title: "Something Went Wrong"
      })
    }

  };

  // function to change to suspend property for an item
  const suspendUser = (id) => {
    let newData = data;
    let index = newData.findIndex((item) => item.id === id);
    newData[index].status = "Suspend";
    setData([...newData]);
  };

  // function to change the check property of an item
  const selectorCheck = (e) => {
    let newData;
    newData = data.map((item) => {
      item.checked = e.currentTarget.checked;
      return item;
    });
    setData([...newData]);
  };

  // function to delete the seletected item
  const selectorDeleteUser = () => {
    let newData;
    newData = data.filter((item) => item.checked !== true);
    setData([...newData]);
  };

  // function to change the complete property of an item
  const selectorSuspendUser = () => {
    let newData;
    newData = data.map((item) => {
      if (item.checked === true) item.status = "Suspend";
      return item;
    });
    setData([...newData]);
  };

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = async (pageNumber) => {
    setLoader(true);
    // let data = {
    //   PageNo: pageNumber,
    //   PageSize: itemPerPage,
    // }
    // let res = await Api.GetUsersPagination(data);
    // if(res?.data?.statusCode === 200){
    //   setData(res?.data?.data?.lstTenant);
    //   SetTotalItems(res?.data?.data?.totalrecord);
    //   setCurrentPage(pageNumber);
    // }else{
    //   setData([]);
    //   SetTotalItems(1);
    //   setCurrentPage(1);
    // }
    const userData2 = await Api.GetTenantUserTable({ IsActive: true, UserName: "", TenantId: +GetTenantIdUp() });
    if (userData2 && userData2?.length > 0) {
      const startIndex = (pageNumber - 1) * itemPerPage;
      const endIndex = startIndex + itemPerPage;
      setTenant(userData2.slice(startIndex, endIndex))
      SetTotalItems(userData2?.length);
      setCurrentPage(pageNumber);
    } else {
      setTenant([])
      SetTotalItems(1);
      setCurrentPage(1);
    }

    // setTenant(userData2);
    setLoader(false);
  };

  ///////////123
  const selectStatus = (event) => {
    setStatus(event.target.value);
  };
  const searchUser = (event) => {
    const { name, value } = event?.target;
    setSearchUserName({ ...searchUserNameState, [name]: value });
  }
  const searchUserList = async () => {
    setLoader(true);
    try {
      // const userData2 = await Api.GetTenantUserTable({ IsActive: statusState, UserName: searchUserNameState, TenantId: 1 });
      // const userData2 = await Api.GetTenant({IsActive : statusState, FirstName: searchUserNameState?.trim()});
      if (searchUserNameState?.firstName?.trim() === "" && searchUserNameState?.lastName?.trim() === "" && searchUserNameState?.userName?.trim() === "") {
        // await callGetTenantList();
        // await paginate(1);
        await callGetUserData();
        await paginate(1);
      } else {
        let searchName = cloneDeep(searchUserNameState);
        const userData2 = await Api.GetUsers(searchName);
        if (userData2?.data?.statusCode === 200) {
          setTenant(userData2?.data?.data);
        } else {
          // Swal.fire({
          //   icon: "error",
          //   // title: userData2?.data?.message,
          //   title: "Something Went Wrong",
          // });
          setTenant([]);
        }
      }

    } catch (error) {
      setTenant([]);
    }
    setLoader(false);

  }
  const handleChange = ({ target }) => {
    const { name, value } = target;
    if (name == "phoneNo") {
      setAddUserDetail({ ...addUserDetailsState, userPhone: { "phoneNo": value } });
    } else {
      setAddUserDetail({ ...addUserDetailsState, [name]: value });
    }
  };
  const handleChangeFor = ({ target }) => {
    const { name, value } = target;
    setTenantDetails({ ...TenantDetailsState, [name]: value });
  };
  const saveAddUser = async (e) => {
    e.preventDefault();
    let errorss = {
      firstName: (regexs?.name?.test(addUserDetailsState?.firstName) ? "" : "Enter Valid First Name"),
      lastName: (regexs?.name?.test(addUserDetailsState?.lastName) ? "" : "Enter Valid Last Name"),
      middleName: (regexs?.name?.test(addUserDetailsState?.middleName) ? "" : "Enter Valid Middle Name"),
      userName: (regexs?.name?.test(addUserDetailsState?.userName) ? "" : "Enter Valid User Name"),
      password: (regexs?.password?.test(addUserDetailsState?.password) ? "" : "Enter Valid Password From 8 to 16 Characters Length Which Include atleast 1 Uppercase, 1 Lowercase, 1 Number and 1 Special Character"),
      emailId: (regexs?.email?.test(addUserDetailsState?.emailId) ? "" : "Enter Valid Email"),
      phoneNo: (usaNumRegex?.test(addUserDetailsState?.userPhone?.phoneNo) ? "" : "Enter Valid Number"),
      SomethingWentWrong: "",
    };
    const formValidate = Object.values(errorss).every(value => value === "");
    if (formValidate) {
      let datas = cloneDeep(addUserDetailsState);
      datas.userPhone.phoneNo = "+1" + datas.userPhone.phoneNo
      const responseInsertTenantUsers = await Api.InsertTenantUsers(datas);
      if (responseInsertTenantUsers?.data?.statusCode === 200) {
        Swal.fire({
          icon: `${responseInsertTenantUsers?.data?.statusCode === 200 ? "success" : "error"}`,
          title: `${responseInsertTenantUsers?.data?.statusCode === 200 ? "User Added Successfully" : "Something Went Wrong"}`,
        })
        callGetUserData();
        await paginate(1);
        resetForm();
        setModal({ ...modal,  add: false });
        setEditModal(false);
        setAddUserDetail(sampleDetail);
      } else if (extractError(responseInsertTenantUsers?.data?.message)?.includes("UserName")) {
        errorss.userName = extractError(responseInsertTenantUsers?.data?.message);
      } else if (extractError(responseInsertTenantUsers?.data?.message)?.includes("EmailID")) {
        errorss.emailId = extractError(responseInsertTenantUsers?.data?.message);
      } else {
        errorss.SomethingWentWrong = "Something Went Wrong";
      }
    }
    setError(errorss)

  }
  const onEditUserSave = async (e) => {
    e?.preventDefault()
    let errorss = {
      firstName: (regexs?.name?.test(TenantDetailsState?.firstName) ? "" : "Enter Valid First Name"),
      lastName: (regexs?.name?.test(TenantDetailsState?.lastName) ? "" : "Enter Valid Last Name"),
      middleName: (regexs?.name?.test(TenantDetailsState?.middleName) ? "" : "Enter Valid Middle Name"),
      userName: (regexs?.name?.test(TenantDetailsState?.userName) ? "" : "Enter Valid User Name"),
      emailId: (regexs?.email?.test(TenantDetailsState?.emailId) ? "" : "Enter Valid Email"),
      phoneNo: (usaNumRegex?.test((TenantDetailsState?.phoneNo)?.replace("+1", "")) ? "" : "Enter Valid Number"),
      SomethingWentWrong: "",
    };
    const formValidate = Object.values(errorss).every(value => value === "");
    if (formValidate) {
      let editForms = cloneDeep(editForm);
      editForms.firstName = TenantDetailsState?.firstName;
      editForms.middleName = TenantDetailsState?.middleName;
      editForms.lastName = TenantDetailsState?.lastName;
      editForms.password = (TenantDetailsState?.password?.substring(0, 8));
      editForms.emailId = TenantDetailsState?.emailId;
      editForms.userName = TenantDetailsState?.userName;
      editForms.userPhone.phoneNo = TenantDetailsState?.phoneNo;
      editForms.userType = editUserType?.value;
      try {
        let datas = cloneDeep(editForms);
        const editUser = await Api.UpdateTenantUsers(datas);
        if (editUser?.statusCode === 200) {
          Swal.fire({
            icon: `${editUser?.statusCode === 200 ? "success" : "error"}`,
            title: `${editUser?.statusCode === 200 ? "User Updated Successfully" : "Something Went Wrong"}`,
          });
          setModal({ ...modal,  add: false })
          setEditModal(false);
          await callGetUserData();
          await paginate(1);
          // await callGetTenantList();
          // await paginate(1);
        } else {
          errorss.SomethingWentWrong = "Something Went Wrong";
        }
      } catch (error) {
        errorss.SomethingWentWrong = "Something Went Wrong";
      }
    }
    setEditError(errorss)
  }
  return (
    <React.Fragment>
      <Head title="User List - Default"></Head>
      <Content className="manageUsers">
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Manage Users
              </BlockTitle>
              <BlockDes className="text-soft">
                <p> Users . Manage Users</p>
              </BlockDes>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard>
            <Row className="">
              <Col lg="3">
                <div className="form-group">
                  <div className="form-control-wrap">
                    <input value={searchUserNameState?.firstName} onChange={eve => searchUser(eve)} className="form-control bg-blue-dim" type="text" id="First-name" placeholder="Enter User Name" name="firstName" />
                  </div>
                </div>
              </Col>
              <Col lg="9" className="responsive_pt">
                <div className="justify-end">
                  <Button onClick={searchUserList} className="me-3 applyBtn">Apply</Button>
                  <Button color="primary" onClick={() => { setModal({ ...modal, edit: false, add: true }); resetError(); }}>
                    <Icon name="plus" />
                    <span>Add</span>
                  </Button>
                </div>
              </Col>
            </Row>
          </PreviewAltCard>
        </Block>

        <Block>
          <div className="nk-tb-list is-separate is-medium mb-3">
            <DataTableHead className="nk-tb-item">
              <DataTableRow>
                <span className="sub-text text-dark fw-bold">Tenant Name</span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text text-dark fw-bold">User Name</span>
              </DataTableRow>
              <DataTableRow size="mb">
                <span className="sub-text text-dark fw-bold">First Name</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text text-dark fw-bold">Last Name</span>
              </DataTableRow>
              <DataTableRow size="lg">
                <span className="sub-text text-dark fw-bold">Email ID</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text text-dark fw-bold">Status</span>
              </DataTableRow>
              <DataTableRow size="lg">
                <span className="sub-text text-dark fw-bold">Action</span>
              </DataTableRow>
            </DataTableHead>
            {/*Head*/}
            {usersDataState?.length > 0
              ? usersDataState?.map((item, ind) => (
                <DataTableItem key={item.tenantUserID} className="nk_tb_col_pad">
                  <DataTableRow>
                    {/* <Link to={`${process.env.PUBLIC_URL}/user-details-regular/${item.id}`}> */}
                    <span>{item.tenantName}</span>
                    {/* </Link> */}
                  </DataTableRow>
                  <DataTableRow size="mb">
                    <span>
                      {item.userName}
                    </span>
                  </DataTableRow>
                  <DataTableRow size="md">
                    <span>{item.firstName}</span>
                  </DataTableRow>
                  <DataTableRow size="lg">
                    <span>{item.lastName}</span>
                  </DataTableRow>
                  <DataTableRow size="lg">
                    <span>{item.emailId}</span>
                  </DataTableRow>
                  <DataTableRow size="md">
                    <span
                      className={`tb-status text-${item.isActive ? "success" : "danger"
                        }`}
                    >
                      {item.isActive ? "Active" : "Inactive"}
                    </span>
                  </DataTableRow>
                  <DataTableRow className="nk-tb-col-tools">
                    <ul className="nk-tb-actions gx-1">
                      <li>
                        <UncontrolledDropdown>
                          <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                            <Icon name="more-h"></Icon>
                          </DropdownToggle>
                          <DropdownMenu end>
                            <ul className="link-list-opt no-bdr">
                              <li onClick={() => { onEditClick(item?.tenantUserID, item?.userName); }} className="dropdown-item" style={{ cursor: "pointer" }}>
                                {/* <DropdownItem > */}
                                <Icon name="edit"></Icon>
                                <span>Edit</span>
                                {/* </DropdownItem> */}
                              </li>
                            </ul>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </li>
                    </ul>
                  </DataTableRow>
                </DataTableItem>
              ))
              : null}
          </div>
          <PreviewAltCard>
            {(usersDataState?.length > 0 && !loader) ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={totalItems}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              !loader ? <div className="d-flex justify-content-center">
                No data Found.
              </div> : ""
            )}
            {loader && <div className="d-flex justify-content-center">
              <Loaders />
            </div>}
          </PreviewAltCard>
        </Block>

        <Modal isOpen={modal.add} toggle={() => { setModal({ ...modal, add: false }); }} className="modal-dialog-centered" size="lg">
          <ModalHeader
            close={
              <button className="close" href="#close"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}>
                <Icon name="cross" />
              </button>
            }
          >
            Add User
          </ModalHeader>
          <ModalBody>
            <form onSubmit={saveAddUser} autoComplete="off">
              <Row className="mb-3">
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">Tenant</label>
                    <div className="form-control-wrap">
                      <RSelect
                        options={filterStatus}
                        defaultValue={{
                          value: formData.status,
                          label: formData.status,
                        }}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                        className="bg-blue-dim"
                      // style={{ backgroundColor: "#e9f2fe"}}
                      />
                    </div>
                  </div>
                </Col>
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">User Type</label>
                    <div className="form-control-wrap">
                      <RSelect
                        options={filterUserType}
                        defaultValue={{
                          value: 1, //formData.status,
                          label: "Administrator", //formData.status,
                        }}
                        className="bg-blue-dim"
                        // onChange={(e) => setFormData({ ...formData, status: e.value })}
                        //setAddUserDetail
                        onChange={(e) => setAddUserDetail({ ...addUserDetailsState, userType: e.value })}
                      />
                    </div>
                  </div>
                </Col>

              </Row>
              <Row className="mb-3">
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">Email ID</label>
                    <input
                      onChange={handleChange}
                      value={addUserDetailsState.emailId}
                      className="form-control bg-blue-dim"
                      type="text"
                      name="emailId"
                      // defaultValue={formData.email}
                      placeholder="Enter email"
                      autoComplete="email"
                    />
                    {error?.emailId !== "" && <span className="invalid">{error?.emailId}</span>}
                  </div>
                </Col>
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">First Name</label>
                    <input
                      onChange={handleChange}
                      value={addUserDetailsState.firstName}
                      className="form-control bg-blue-dim"
                      type="text"
                      name="firstName"
                      // defaultValue={formData.name}
                      placeholder="Enter name"
                      autoComplete="firstname"
                    />
                    {error?.firstName !== "" && <span className="invalid">{error?.firstName}</span>}
                  </div>
                </Col>

              </Row>
              <Row className="mb-3">
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">Middle Name</label>
                    <input
                      onChange={handleChange}
                      value={addUserDetailsState.middleName}
                      className="form-control bg-blue-dim"
                      type="text"
                      name="middleName"
                      // defaultValue={formData.name}
                      placeholder="Enter name"
                      autoComplete="middlename"
                    />
                    {error?.middleName !== "" && <span className="invalid">{error?.middleName}</span>}
                  </div>
                </Col>
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">Last Name</label>
                    <input
                      onChange={handleChange}
                      value={addUserDetailsState.lastName}
                      className="form-control bg-blue-dim"
                      type="text"
                      name="lastName"
                      // defaultValue={formData.name}
                      placeholder="Enter name"
                      autoComplete="lastname"
                    />
                    {error?.lastName !== "" && <span className="invalid">{error?.lastName}</span>}
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">User Name</label>
                    <input
                      onChange={handleChange}
                      value={addUserDetailsState.userName}
                      className="form-control bg-blue-dim"
                      type="text"
                      name="userName"
                      placeholder="Enter name"
                      // autoComplete="username"
                      autoComplete="off"
                    />
                    {error?.userName !== "" && <span className="invalid">{error?.userName}</span>}
                  </div>
                </Col>
                <Col md="6">
                  <div className={`form-group `}>
                    <label className="form-label">Password</label>
                    <input
                      onChange={handleChange}
                      value={addUserDetailsState.password}
                      className="form-control bg-blue-dim"
                      type={passState ? "text" : "password"}
                      name="password"
                      placeholder="Enter password"
                      autoComplete="off"
                    // autoComplete="current-password"
                    />
                    <a href="#password" onClick={(ev) => { ev.preventDefault(); setPassState(!passState); }} style={{ top: "25px" }} className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`} >
                      <Icon name="eye" className="passcode-icon icon-show"></Icon>
                      <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                    </a>
                    {error?.password !== "" && <span className="invalid">{error?.password}</span>}
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">Phone Number</label>
                    <InputMask
                      onChange={handleChange}
                      value={addUserDetailsState.userPhone.phoneNo}
                      name="phoneNo"
                      mask='(999) 999-9999'
                      className="form-control bg-blue-dim"
                      placeholder="(999) 999-9999"
                      autoComplete="phone"
                    // defaultValue={formData.phone}
                    >
                    </InputMask>
                    {error?.phoneNo !== "" && <span className="invalid">{error?.phoneNo}</span>}
                    {error?.SomethingWentWrong !== "" && <span className="invalid">{error?.SomethingWentWrong}</span>}
                  </div>
                </Col>
              </Row>
              {/* <Row className="mb-3">
         
              </Row> */}
              <div className="justify-end mt-4">
                <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                  <li>
                    <Button onClick={saveAddUser} color="primary" size="md" type="submit">
                      Save
                    </Button>
                  </li>
                  <li>
                    <a
                      href="#cancel"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onFormCancel();
                      }}
                      className="link link-light"
                    >
                      Cancel
                    </a>
                  </li>
                </ul>
              </div>
            </form>
          </ModalBody>
        </Modal>

        <Modal isOpen={editModal} toggle={() => { setEditModal(false); }} className="modal-dialog-centered" size="lg">
          <ModalHeader
            close={
              <button className="close" href="#close"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}>
                <Icon name="cross" />
              </button>
            }
          >
            Edit User
          </ModalHeader>
          <ModalBody>
            <form onSubmit={onEditUserSave}>
              <Row className="mb-3">
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">Tenant</label>
                    <div className="form-control-wrap">
                      <RSelect
                        options={filterStatus}
                        defaultValue={{
                          value: formData.status,
                          label: formData.status,
                        }}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                    </div>
                  </div>

                </Col>
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">User Type</label>
                    <div className="form-control-wrap">
                      <RSelect
                        options={filterUserType}
                        defaultValue={editUserType}
                        onChange={(e) => {
                          setAddUserDetail({ ...addUserDetailsState, userType: e.value });
                          setEditUserType({ ...editUserType, label: e?.label, value: e?.value })
                        }}
                      />
                    </div>
                  </div>
                </Col>

              </Row>
              <Row className="mb-3">
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">Email ID</label>
                    <input
                      onChange={handleChangeFor}
                      value={TenantDetailsState?.emailId}
                      className="form-control bg-blue-dim"
                      type="text"
                      name="emailId"
                      placeholder="Enter email"
                      autoComplete="email"
                    />
                    {editError?.emailId !== "" && <span className="invalid">{editError?.emailId}</span>}
                  </div>
                </Col>
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">First Name</label>
                    <input
                      onChange={handleChangeFor}
                      value={TenantDetailsState.firstName}
                      className="form-control bg-blue-dim"
                      type="text"
                      name="firstName"
                      placeholder="Enter name"
                      autoComplete="firstname"
                    />
                    {editError?.firstName !== "" && <span className="invalid">{editError?.firstName}</span>}
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">Middle Name</label>
                    <input
                      onChange={handleChangeFor}
                      value={TenantDetailsState.middleName}
                      className="form-control bg-blue-dim"
                      type="text"
                      name="middleName"
                      // defaultValue={formData.name}
                      placeholder="Enter name"
                      autoComplete="middlename"
                    />
                    {editError?.middleName !== "" && <span className="invalid">{editError?.middleName}</span>}
                  </div>
                </Col>
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">Last Name</label>
                    <input
                      onChange={handleChangeFor}
                      value={TenantDetailsState.lastName}
                      className="form-control bg-blue-dim"
                      type="text"
                      name="lastName"
                      // defaultValue={formData.lastname}
                      placeholder="Enter name"
                      autoComplete="lastname"
                    />
                    {editError?.lastName !== "" && <span className="invalid">{editError?.lastName}</span>}
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">User Name</label>
                    <input
                      onChange={handleChangeFor}
                      value={TenantDetailsState.userName}
                      className="form-control bg-blue-dim"
                      type="text"
                      name="userName"
                      autoComplete="username"
                      placeholder="Enter name"
                    />
                    {editError?.userName !== "" && <span className="invalid">{editError?.userName}</span>}
                  </div>
                </Col>
                {/* <Col md="6">
                  <div className="form-group">
                    <label className="form-label">Password</label>
                    <input
                      onChange={handleChangeFor}
                      value={TenantDetailsState.password}
                      className="form-control bg-blue-dim"
                      type="password"
                      name="password"
                      placeholder="Enter password"
                      disabled={true}
                      autoComplete="current-password"
                    />
                    {editError?.password !== "" && <span className="invalid">{editError?.password}</span>}
                  </div>
                </Col> */}
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">Phone Number</label>
                    <InputMask
                      name="phoneNo"
                      onChange={handleChangeFor}
                      value={TenantDetailsState.phoneNo}
                      mask='(999) 999-9999'
                      className="form-control bg-blue-dim"
                      placeholder="(999) 999-9999"
                      autoComplete="phonenumber"
                    >
                    </InputMask>
                    {editError?.phoneNo !== "" && <span className="invalid">{editError?.phoneNo}</span>}
                    {editError?.SomethingWentWrong !== "" && <span className="invalid">{editError?.SomethingWentWrong}</span>}
                  </div>
                </Col>
              </Row>
              {/* <Row className="mb-3">
           
              </Row> */}
              <div className="justify-end mt-4">
                <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                  <li>
                    <Button onClick={onEditUserSave} color="primary" size="md" type="submit">
                      Save
                    </Button>
                  </li>
                  <li>
                    <a
                      href="#cancel"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onFormCancel();
                      }}
                      className="link link-light"
                    >
                      Cancel
                    </a>
                  </li>
                </ul>
              </div>
            </form>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
export default ManageUsers;
